module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_02@2x-e0ffc3eed27ed84c24edc8b49c246631.webp";